import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { VOTE_TARGET_OPTIONS } from "@/constants/forms";

interface SubmissionTypeStepProps {
  isPaid: boolean;
  votesTarget: number;
  onIsPaidChange: (isPaid: boolean) => void;
  onVotesTargetChange: (target: number) => void;
}

export function SubmissionTypeStep({
  isPaid,
  votesTarget,
  onIsPaidChange,
  onVotesTargetChange,
}: SubmissionTypeStepProps) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <Card
          className={cn(
            "cursor-pointer p-6 transition-all hover:bg-accent/10",
            !isPaid ? "border-primary bg-primary/10" : "border-border bg-card"
          )}
          onClick={() => onIsPaidChange(false)}
        >
          <h3 className="font-semibold">Envio Gratuito</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            Receba avaliações do público geral sem segmentação demográfica
          </p>
        </Card>

        <Card
          className={cn(
            "cursor-pointer p-6 transition-all hover:bg-accent/10",
            isPaid ? "border-primary bg-primary/10" : "border-border bg-card"
          )}
          onClick={() => onIsPaidChange(true)}
        >
          <h3 className="font-semibold">Envio Pago</h3>
          <p className="mt-1 text-sm text-muted-foreground">
            Segmente demografias específicas para feedback mais relevante
          </p>
        </Card>
      </div>

      {isPaid && (
        <div className="space-y-2">
          <Label className="text-foreground">Meta de Votos</Label>
          <Select
            value={String(votesTarget)}
            onValueChange={(value) => onVotesTargetChange(Number(value))}
          >
            <SelectTrigger className="border-input bg-background text-foreground">
              <SelectValue placeholder="Selecione a meta de votos" />
            </SelectTrigger>
            <SelectContent className="border-border bg-card">
              {VOTE_TARGET_OPTIONS.map((target) => (
                <SelectItem key={target} value={String(target)}>
                  {target} votos
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
